import { render, staticRenderFns } from "./St21Cn2061ReportQuarter.vue?vue&type=template&id=6f4ef8fa&scoped=true&"
import script from "./St21Cn2061ReportQuarter.vue?vue&type=script&lang=js&"
export * from "./St21Cn2061ReportQuarter.vue?vue&type=script&lang=js&"
import style0 from "./St21Cn2061ReportQuarter.vue?vue&type=style&index=0&id=6f4ef8fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4ef8fa",
  null
  
)

export default component.exports